
	import Vue from "vue";

	export default Vue.extend({
		name: "RecoverPasswordForm",
		props: {
			/**
			 * Shows spinner when logging in
			 * @values true, false
			 */
			loading: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				/**
				 * Validation Object. It has all the validation functions needed to validate inputs.
				 **/
				// validations: validations,
				/**
				 * Recovery mail for password reset.
				 **/
				recoveryMail: "",
			};
		},
		methods: {
			/**
			 * Resets reset password form validations.
			 * @public
			 **/
			resetRecoveryPasswordValidation() {
				// eslint-disable-next-line
				const form: any = this.$refs.resetPass;
				if (form && form.validate()) {
					form.resetValidation();
				}
			},
			/**
			 * Emits the reset password event to parent.
			 * @public
			 **/
			sendReset() {
				/** Validates login form **/
				// eslint-disable-next-line
				const form: any = this.$refs.resetPass;
				if (form && form.validate()) {
					this.$emit("sendReset", this.recoveryMail);
				}
			},
			/**
			 * Sends to login.
			 * @public
			 **/
			toLogin() {
				this.$emit("toLogin");
			},
			reset() {
				const form: any = this.$refs.resetPass;
				if (form) {
					form.reset();
				}
			},
		},
	});
